import { Home, User, Crown } from 'lucide-react';
import { Box, HStack, Button, Text, Icon, useColorModeValue } from '@chakra-ui/react';
import type { PageType } from '../App';

interface BottomNavigationProps {
  currentPage: PageType;
  onPageChange: (page: PageType) => void;
}

export function BottomNavigation({ currentPage, onPageChange }: BottomNavigationProps) {
  const bgColor = useColorModeValue('white', 'gray.800');

  const navItems = [
    {
      id: 'integrations' as PageType,
      label: 'Главная',
      icon: Home
    },
    {
      id: 'profile' as PageType,
      label: 'Профиль',
      icon: User
    },
    {
      id: 'subscriptions' as PageType,
      label: 'Подписки',
      icon: Crown
    }
  ];

  return (
    <Box 
      position="fixed"
      bottom={0}
      left={0}
      right={0}
      bg={bgColor}
      p={2}
      pb={{ base: 6, md: 2 }}
      zIndex={1000}
      boxShadow="0 -2px 10px rgba(0,0,0,0.1)"
    >
      <Box maxW="md" mx="auto">
        <HStack spacing={0} justify="space-around">
          {navItems.map((item) => {
            const IconComponent = item.icon;
            const isActive = currentPage === item.id;
            
            return (
              <Button
                key={item.id}
                variant="ghost"
                size="sm"
                flex={1}
                flexDirection="column"
                height="auto"
                py={2}
                color={isActive ? 'blue.500' : 'gray.600'}
                bg={isActive ? 'blue.50' : 'transparent'}
                _hover={{
                  bg: isActive ? 'blue.50' : 'gray.50',
                  color: isActive ? 'blue.500' : 'gray.800'
                }}
                onClick={() => onPageChange(item.id)}
              >
                <Icon as={IconComponent} w={5} h={5} mb={1} />
                <Text fontSize="xs">{item.label}</Text>
              </Button>
            );
          })}
        </HStack>
      </Box>
    </Box>
  );
}